import { createFileRoute } from '@tanstack/react-router'

import { zmpSettingQueryOptions } from '@/common/hooks/useGetZMPSetting'
import CategoryPage from '@/layouts/themes/phong-nha/pages/category'

export const Route = createFileRoute('/phong-nha/category/')({
  validateSearch: (search): { cat?: string } => ({
    cat: typeof search.cat === 'string' ? search.cat : undefined,
  }),
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(zmpSettingQueryOptions),
  head: ({ loaderData }) => {
    const siteName = loaderData?.meta?.site_name || loaderData?.appName
    const title = siteName ? `Danh mục | ${siteName}` : 'Danh mục'

    return {
      meta: [
        { title },
        { property: 'og:title', content: title },
      ],
    }
  },
  component: CategoryPage,
})
